<template>
  <div v-show="show" class="adv-listing-used-filters">
    <AdvListingUsedFiltersClear></AdvListingUsedFiltersClear>
    <div class="adv-listing-used-filters-content">
      <div class="native_slider">
        <div class="native_slider-lg" data-drag_speed="2">
          <AdvListingUsedTag
            class="native_slider-li"
            v-for="(tag, index) in getTagRecordsUsedFlat"
            :tag="tag"
            :group="getGroupForTag(tag.tagId)"
            :key="index"
            :index="Number(index)"
          >
          </AdvListingUsedTag>
          <AdvListingUsedAttribute
            class="native_slider-li"
            v-for="(attribute, index) in getAttributeRecordsUsedFlat"
            :attribute="attribute"
            :group="getGroupForAttribute(attribute.attributeId)"
            :key="index"
            :index="Number(index)"
          >
          </AdvListingUsedAttribute>
          <AdvListingUsedVariation
            class="native_slider-li"
            v-for="(variation, index) in getVariationRecordsUsedFlat"
            :variation="variation"
            :group="getGroupForVariation(variation.variationId)"
            :key="index"
            :index="Number(index)"
          >
          </AdvListingUsedVariation>
        </div>
      </div>
    </div>
    <slot name="extra-actions"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdvListingUsedTag from './AdvListingUsedTag.vue'
import AdvListingUsedFiltersClear from './AdvListingUsedFiltersClear.vue'
import { cloneDeep } from 'lodash-es'
import AdvListingUsedAttribute from './AdvListingUsedAttribute.vue'
import AdvListingUsedVariation from './AdvListingUsedVariation.vue'

export default {
  name: 'AdvListingUsedFilters',
  components: {
    AdvListingUsedTag,
    AdvListingUsedFiltersClear,
    AdvListingUsedAttribute,
    AdvListingUsedVariation
  },
  computed: {
    ...mapGetters([
      'getTagRecordsUsed',
      'getAttributeRecordsUsed',
      'getListingAttributeGroupCombos',
      'getVariationRecordsUsed',
      'getListingVariationGroupCombos',
      'getListingTagGroupCombos'
    ]),
    show () {
      return Object.keys(this.getTagRecordsUsed).length > 0 ||
        Object.keys(this.getAttributeRecordsUsedFlat).length > 0 ||
        Object.keys(this.getVariationRecordsUsedFlat).length > 0
    },
    getTagRecordsUsedFlat () {
      const tagRecordsUsed = cloneDeep(this.getTagRecordsUsed)
      const flatObject = {}
      for (const outerKey in tagRecordsUsed) {
        const innerObject = tagRecordsUsed[outerKey]
        for (const innerKey in innerObject) {
          flatObject[innerKey] = innerObject[innerKey]
        }
      }
      return flatObject
    },
    getAttributeRecordsUsedFlat () {
      const attributeRecordsUsed = cloneDeep(this.getAttributeRecordsUsed)
      const flatObject = {}
      for (const outerKey in attributeRecordsUsed) {
        const innerObject = attributeRecordsUsed[outerKey]
        for (const innerKey in innerObject) {
          flatObject[innerKey] = innerObject[innerKey]
        }
      }
      return flatObject
    },
    getVariationRecordsUsedFlat () {
      const variationRecordsUsed = cloneDeep(this.getVariationRecordsUsed)
      const flatObject = {}
      for (const outerKey in variationRecordsUsed) {
        const innerObject = variationRecordsUsed[outerKey]
        for (const innerKey in innerObject) {
          flatObject[innerKey] = innerObject[innerKey]
        }
      }
      return flatObject
    }
  },
  methods: {
    getGroupForAttribute (attributeId) {
      const attributeGroupCombos = this.getListingAttributeGroupCombos
      for (const attributeGroupCombo of attributeGroupCombos) {
        for (const attribute of attributeGroupCombo.attributes) {
          if (Number(attribute.attributeId) === Number(attributeId)) {
            return attributeGroupCombo
          }
        }
      }
    },
    getGroupForVariation (variationId) {
      const variationGroupCombos = this.getListingVariationGroupCombos
      for (const variationGroupCombo of variationGroupCombos) {
        for (const variation of variationGroupCombo.variations) {
          if (Number(variation.variationId) === Number(variationId)) {
            return variationGroupCombo
          }
        }
      }
    },
    getGroupForTag (tagId) {
      const tagGroupCombos = this.getListingTagGroupCombos
      for (const tagGroupCombo of tagGroupCombos) {
        for (const tag of tagGroupCombo.tags) {
          if (Number(tag.tagId) === Number(tagId)) {
            return tagGroupCombo
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.native_slider {
  max-height: 40px;
}
.native_slider-lg {
  grid-auto-columns: max-content;
  gap: 10px;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, auto);
    grid-auto-flow: row;
  }
}
.adv-listing-used-filters {
  display: grid;
  gap: 1rem;
  margin-top: 1rem;
  grid-template-columns: 150px auto auto;
  align-items: center;
  margin-bottom: 45px;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  &-content {
    position: relative;
    width: 100%;
    max-width: 1000px;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
